import type { ReactNode } from 'react';

import { Icon } from '../Icon.js';

/**
 * LEVEL 3: THERE WHEN ASKED FOR.
 *
 * Detail somebody needs sometimes — the method behind a figure, the screenplay
 * beside a requirement, an advanced setting — folded under one line that says
 * what is inside. A native `<details>`, so it opens from the keyboard, is
 * announced as expandable and needs no state to keep.
 */
export function Disclosure({
  summary,
  meta,
  children,
  defaultOpen = false,
  testId,
}: {
  summary: ReactNode;
  meta?: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  testId?: string;
}) {
  return (
    <details className="ui-disclosure" open={defaultOpen} data-testid={testId}>
      <summary>
        <Icon name="chevronRight" size={14} />
        <span className="ui-disclosure-summary">{summary}</span>
        {meta === undefined ? null : <span className="ui-disclosure-meta">{meta}</span>}
      </summary>
      <div className="ui-disclosure-body">{children}</div>
    </details>
  );
}
